import { User } from 'src/@types/user';
import API from 'src/helpers/api';
import { getErrorMessage } from 'src/helpers/axios';

interface GetProfileDetailResponse {
  user: User;
}

interface GetProfileDetailResult {
  user?: User;
  error?: string;
}

const getProfileDetail = async (): Promise<GetProfileDetailResult> => {
  const result: GetProfileDetailResult = {};
  try {
    const response = await API.get<GetProfileDetailResponse>('/profile');
    result.user = response.data.user;
  } catch (error) {
    result.error = getErrorMessage(error);
  }
  return result;
};

const LoggedUserService = {
  getProfileDetail,
};

export default LoggedUserService;
